// extracted by mini-css-extract-plugin
export default {"Escultura":"Pinturas_Escultura__HAJLV","Navbar":"Pinturas_Navbar__Z-88A"};